import { useSelector } from 'react-redux';

import { Trans, t } from '@lingui/macro';

import { isComparativeViewFacet } from 'selectors/facet';
import {
  aggregatesSelector,
  viewFacetAggregatesLoadingSelector,
} from 'selectors/view';

import {
  getReviewScoreInterpolatedColor,
  getSentimentKpiColor,
} from 'utils/colors';
import commonPropTypes from 'utils/commonPropTypes';
import {
  floatFormatter,
  zeroPrecisionFloatFormatter,
  zeroPrecisionPercentFormatter,
} from 'utils/formatter';

import * as svars from 'assets/style/variables';

import {
  averageScoreHelpMessage,
  averageSentimentHelpMessage,
} from '../v2/helpMessageV2';
import DashboardKpi from './dashboard/DashboardKpi';

function ViewFacetDashboardKpis({ viewFacet }) {
  const { kpis, competitionKpis } = useSelector(aggregatesSelector);

  const aggregatesLoading = useSelector(viewFacetAggregatesLoadingSelector);
  let differentialSentiment = '-';
  let differentialSentimentIncrease = '-';
  const isComparative = isComparativeViewFacet(viewFacet);
  if (isComparative && competitionKpis) {
    if (competitionKpis.benchmarkKpis && competitionKpis.benchmarkKpis.length) {
      differentialSentiment =
        competitionKpis.benchmarkKpis[0].average_sentiment_differential;
    }
    if (
      kpis &&
      competitionKpis.increases &&
      competitionKpis.increases['1M'] &&
      kpis.increases &&
      kpis.increases['1M']
    ) {
      differentialSentimentIncrease =
        kpis.increases['1M'][0].average_sentiment -
        competitionKpis.increases['1M'][0].average_sentiment;
    }
  }

  return (
    <>
      <DashboardKpi
        headerTextId={t({ id: 'volume' })}
        loading={aggregatesLoading}
        value={kpis?.kpis?.[0]?.n_chunks}
        increase={kpis?.increases?.['1M']?.[0]?.n_chunks}
        increaseFormatter={zeroPrecisionPercentFormatter}
        color={svars.volumeColor}
        description={<Trans id="help-message.volume-description" />}
        kpiValueTestId="volume"
        articleId={23}
      />
      <DashboardKpi
        headerTextId={t({ id: 'sentiment' })}
        loading={aggregatesLoading}
        value={kpis?.kpis?.[0]?.average_sentiment}
        increase={kpis?.increases?.['1M']?.[0]?.average_sentiment}
        color={getSentimentKpiColor}
        formatter={floatFormatter}
        increaseFormatter={floatFormatter}
        description={<Trans id={averageSentimentHelpMessage} />}
        articleId={7}
        kpiValueTestId="sentiment"
      />
      {viewFacet.use_review_score ? (
        <DashboardKpi
          headerTextId={t({ id: 'review-score' })}
          loading={aggregatesLoading}
          value={kpis?.kpis?.[0]?.average_score}
          increase={kpis?.increases?.['1M']?.[0]?.average_score}
          color={getReviewScoreInterpolatedColor}
          formatter={zeroPrecisionFloatFormatter}
          increaseFormatter={zeroPrecisionFloatFormatter}
          description={<Trans id={averageScoreHelpMessage} />}
          articleId={7}
          kpiValueTestId="review_score"
        />
      ) : null}
      {differentialSentiment !== '-' ? (
        <DashboardKpi
          headerTextId={t({ id: 'differential-sentiment' })}
          loading={aggregatesLoading}
          value={differentialSentiment}
          increase={differentialSentimentIncrease}
          color={getSentimentKpiColor}
          formatter={floatFormatter}
          increaseFormatter={floatFormatter}
          disabled={!isComparative}
        />
      ) : null}
    </>
  );
}

ViewFacetDashboardKpis.propTypes = {
  viewFacet: commonPropTypes.viewFacet.isRequired,
};

export default ViewFacetDashboardKpis;
